import * as React from 'react';

export function SvgFirefoxLogo(props: any) {
  return (
    <svg
      width="96"
      height="99"
      viewBox="0 0 96 99"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2_3887)">
        <path
          d="M77.3755 9.37085C74.977 12.1637 73.8599 18.4493 76.292 24.8212C78.7241 31.1931 82.4518 29.8092 84.7755 36.3068C87.8427 44.8806 86.4151 56.3979 86.4151 56.3979C86.4151 56.3979 90.1024 67.0759 92.6719 55.7335C98.3593 34.4291 77.3755 14.6171 77.3755 9.37085Z"
          fill="url(#paint0_radial_2_3887)"
        />
        <path
          d="M48.1074 97.8203C72.6703 97.8203 92.5685 77.8143 92.5685 53.146C92.5685 28.4776 72.6703 8.4718 48.1312 8.4718C23.5922 8.4718 3.69412 28.4777 3.69412 53.146C3.64654 77.8382 23.5682 97.8203 48.1074 97.8203Z"
          fill="url(#paint1_radial_2_3887)"
        />
        <path
          d="M81.421 80.6927C80.4599 81.3707 79.4516 81.9793 78.4038 82.5139C79.7918 80.4802 81.0722 78.3753 82.24 76.2077C83.1875 75.159 84.0555 74.1396 84.7628 73.0373C85.1071 72.4958 85.4953 71.8275 85.9062 71.0522C88.4023 66.5551 91.1546 59.2771 91.2327 51.8014V51.7834C91.2345 51.5994 91.2356 51.4153 91.2341 51.231C91.247 49.3545 91.0551 47.4822 90.662 45.6473C90.682 45.7906 90.6996 45.9339 90.7176 46.0771C90.6955 45.9669 90.6769 45.8555 90.6531 45.7452C90.6898 45.9489 90.7192 46.1458 90.7509 46.3444C91.2611 50.673 90.8977 54.8953 89.08 58.0081C89.0514 58.0536 89.0219 58.0961 88.993 58.1406C89.9355 53.4096 90.2508 48.186 89.2021 42.9563C89.2021 42.9563 88.7828 40.4139 85.6589 32.6958C83.8608 28.2534 80.6676 24.6112 77.8464 21.9579C75.3734 18.8984 73.1274 16.8452 71.8893 15.5416C69.3031 12.8184 68.2191 10.7771 67.774 9.44518C67.3881 9.25167 62.452 4.4565 62.0599 4.2738C59.9053 7.61435 53.1294 18.0634 56.3527 27.8261C57.8134 32.2504 61.5076 36.8422 65.3738 39.4182C65.5436 39.6121 67.6744 41.9264 68.6877 47.1463C69.734 52.5391 69.1839 56.7472 67.0304 62.9699C64.4978 68.4292 58.0093 73.8261 51.9339 74.3782C38.9455 75.5582 34.1906 67.8569 34.1906 67.8569C38.8316 69.7124 43.963 69.3243 47.0836 67.4006C50.2287 65.455 52.1311 64.0125 53.6752 64.5813C55.1976 65.1475 56.4096 63.504 55.322 61.8001C54.4822 60.5066 53.2804 59.4886 51.8664 58.8729C50.4523 58.2571 48.8884 58.0709 47.3693 58.3373C44.221 58.849 41.337 61.343 37.2118 58.9277C36.9448 58.7727 36.6864 58.6035 36.4377 58.4206C36.1658 58.2419 37.3217 58.6928 37.052 58.4896C36.2492 58.0535 34.8284 57.1031 34.4598 56.7651C34.3984 56.7088 35.0827 56.9833 35.0213 56.927C31.1642 53.7507 31.6459 51.605 31.7671 50.2593C31.8642 49.1827 32.5648 47.803 33.7454 47.2435C34.3156 47.5546 34.6709 47.7922 34.6709 47.7922C34.6709 47.7922 34.4277 47.2953 34.2962 47.0334C34.3422 47.0134 34.3863 47.0187 34.4322 46.9992C34.8993 47.2246 35.9323 47.8105 36.4762 48.1677C37.1845 48.6673 37.4103 49.1128 37.4103 49.1128C37.4103 49.1128 37.5967 49.0102 37.4588 48.5745C37.4087 48.3958 37.1937 47.828 36.4921 47.255L36.536 47.2599C36.9559 47.4992 37.3537 47.7754 37.7246 48.0853C37.9224 47.3661 38.2781 46.6151 38.1999 45.2716C38.1521 44.327 38.1742 44.0824 38.0077 43.7176C37.8587 43.4043 38.0912 43.2821 38.3501 43.6074C38.3058 43.3525 38.2315 43.1038 38.1289 42.8663L38.1311 42.8418C38.4541 41.7164 44.9668 38.7892 45.4409 38.4471C46.2198 37.896 46.8729 37.1859 47.3572 36.3637C47.7194 35.7865 47.9919 34.9767 48.0583 33.7484C48.0938 32.8625 47.6818 32.2726 41.0965 31.5831C39.2955 31.4057 38.2388 30.1007 37.6383 28.8965C37.5287 28.6371 37.4171 28.402 37.3053 28.1671C37.1986 27.8926 37.1129 27.6103 37.0491 27.3227C38.1257 24.2304 39.9347 21.6159 42.5946 19.6404C42.7396 19.5084 42.0155 19.6742 42.1604 19.5422C42.3293 19.3882 43.433 18.9436 43.6414 18.8434C43.896 18.7232 42.5515 18.1523 41.3646 18.2913C40.1557 18.4276 39.899 18.5718 39.2539 18.8453C39.5216 18.5788 40.373 18.2294 40.1734 18.2317C38.8702 18.4316 37.2508 19.1891 35.8665 20.047C35.8638 19.8976 35.8923 19.7493 35.9501 19.6115C35.305 19.8852 33.7206 20.9926 33.2593 21.9295C33.2792 21.7499 33.2881 21.5693 33.286 21.3886C32.7945 21.7985 32.3511 22.2628 31.9643 22.7726L31.9402 22.7945C28.1984 21.2871 24.9056 21.1896 22.1192 21.8654C21.5096 21.2533 21.2118 21.7008 19.8248 18.6534C19.7306 18.4699 19.8971 18.8346 19.8248 18.6534C19.5967 18.0625 19.9639 19.4419 19.8248 18.6534C17.4927 20.4936 14.4242 22.579 12.9512 24.051C12.933 24.1097 14.6696 23.5603 12.9512 24.051C12.3495 24.2229 12.3903 24.58 12.2989 27.8071C12.2768 28.0518 12.2964 28.3258 12.2765 28.546C11.0999 30.0452 10.2985 31.3148 9.99539 31.9726C8.47366 34.5948 6.79768 38.6826 5.17308 45.1488C5.88966 43.3961 6.7536 41.7073 7.75561 40.1006C6.40465 43.5328 5.09866 48.9225 4.83754 57.2225C5.16435 55.5098 5.58339 53.816 6.09285 52.1484C5.77391 59.0344 6.96139 65.907 9.57242 72.2867C10.5068 74.5725 12.0524 78.0414 14.6835 81.842C22.95 90.5398 34.6099 95.9546 47.5212 95.9546C61 95.9547 73.1037 90.0574 81.421 80.6927Z"
          fill="url(#paint2_linear_2_3887)"
        />
        <path
          d="M71.4475 87.01C87.7606 85.121 94.9821 68.3101 85.7084 67.9796C77.3317 67.7118 63.7206 87.9014 71.4475 87.01Z"
          fill="url(#paint3_radial_2_3887)"
        />
        <path
          d="M86.8829 64.5457C98.1065 58.0138 95.1801 43.9047 95.1801 43.9047C95.1801 43.9047 90.8486 48.9365 87.9059 56.9575C84.9992 64.9002 80.1351 68.4908 86.8829 64.5457Z"
          fill="url(#paint4_radial_2_3887)"
        />
        <path
          d="M51.2526 95.3589C66.9003 100.352 80.3492 88.0251 72.0592 83.9085C64.522 80.196 43.8257 92.9979 51.2526 95.3589Z"
          fill="url(#paint5_radial_2_3887)"
        />
        <path
          d="M88.049 70.5362C88.4296 69.9991 88.9444 68.2791 89.3991 67.5103C92.1618 63.0509 92.1813 59.4952 92.1813 59.4137C93.8499 51.0785 93.6985 47.675 92.6721 41.3806C91.8456 36.3125 88.2328 29.0517 85.103 25.5553C81.8778 21.953 84.15 23.1267 81.0272 20.4954C78.2902 17.4612 75.6363 14.4566 74.191 13.2483C63.7467 4.5166 63.9827 2.66193 64.1838 2.34573C64.1498 2.38289 64.1 2.43808 64.0364 2.51029C63.9127 2.0172 63.8253 1.60254 63.8253 1.60254C63.8253 1.60254 58.1162 7.31167 56.9143 16.8269C56.1296 23.0389 58.455 29.5148 61.8221 33.6538C63.5754 35.7988 65.5569 37.7467 67.7316 39.4631V39.4605C70.2756 43.1141 71.6759 47.6225 71.6759 52.4722C71.6759 64.6161 61.826 74.4605 49.6755 74.4605C48.0195 74.4614 46.3687 74.2759 44.7542 73.9077C39.0214 72.8152 35.7109 69.9233 34.0599 67.96C33.1137 66.8348 32.7113 66.0146 32.7113 66.0146C37.8479 67.8547 43.5272 67.4697 46.981 65.5621C50.4614 63.6325 52.5673 62.2021 54.2763 62.7661C55.961 63.3276 57.3023 61.6977 56.0993 60.0081C54.9203 58.3209 51.8525 55.9045 47.2974 56.574C43.8129 57.0815 40.621 59.5548 36.0554 57.1594C35.7613 57.0067 35.4754 56.8388 35.1986 56.6566C34.8976 56.4792 36.177 56.9266 35.8784 56.7249C34.99 56.2924 33.4172 55.3499 33.0095 55.0148C32.9415 54.959 33.6989 55.2312 33.6305 55.1751C29.3616 52.0251 29.8945 49.8973 30.0288 48.5627C30.1363 47.495 30.9117 46.1268 32.2182 45.5719C32.8493 45.8805 33.2425 46.1161 33.2425 46.1161C33.2425 46.1161 32.9733 45.6233 32.8277 45.3636C32.8787 45.3441 32.9273 45.349 32.978 45.3296C33.495 45.5532 34.6382 46.1338 35.2402 46.4885C36.0241 46.984 36.274 47.4258 36.274 47.4258C36.274 47.4258 36.4805 47.324 36.3277 46.8919C36.2719 46.7147 36.0344 46.1516 35.2578 45.5833L35.3064 45.5882C35.7674 45.8232 36.2075 46.0971 36.6219 46.4068C36.8408 45.6936 37.2347 44.9488 37.148 43.6165C37.0951 42.6798 37.1196 42.4371 36.9353 42.0754C36.7703 41.7649 37.0278 41.6435 37.3141 41.9664C37.2646 41.7117 37.1823 41.4645 37.0693 41.2309L37.0718 41.2067C37.4294 40.0906 44.6374 37.1878 45.1621 36.8484C46.0075 36.3178 46.7304 35.6134 47.283 34.7821C47.6836 34.2097 47.9855 33.4066 48.059 32.1885C48.0836 31.6396 47.9147 31.2052 46.0057 30.7897C44.86 30.5403 43.0874 30.2977 40.3534 30.0411C38.3602 29.8653 37.1906 28.5712 36.526 27.3769C36.4047 27.1196 36.2812 26.8861 36.1575 26.6535C36.0399 26.3828 35.945 26.1027 35.8739 25.8162C37.0666 22.6938 39.2146 20.0276 42.0116 18.1977C42.1719 18.0667 41.3706 18.2312 41.5308 18.1003C41.7179 17.9476 42.9394 17.5067 43.1702 17.4073C43.4519 17.2885 41.9638 16.7222 40.6502 16.8599C39.3124 16.995 39.0282 17.1379 38.3142 17.4093C38.6106 17.145 39.5528 16.7984 39.3319 16.8009C37.8896 16.999 36.0968 17.7503 34.5643 18.601C34.5615 18.4519 34.5932 18.3041 34.6569 18.1691C33.9428 18.4405 32.1892 19.5387 31.6787 20.4678C31.7006 20.2899 31.7105 20.1108 31.7081 19.9316C31.1704 20.3323 30.6799 20.7926 30.2458 21.3038L30.219 21.3256C26.0777 19.8307 22.4334 19.7339 19.3495 20.4041C18.6748 19.7971 17.59 18.8791 16.055 15.8568C15.9507 15.6749 15.8947 16.2329 15.8146 16.0533C15.2181 14.6697 14.8578 12.403 14.917 10.8403C14.917 10.8403 13.6832 11.4026 12.6621 13.751C12.4725 14.1732 12.3509 14.406 12.2294 14.6389C12.1735 14.7068 12.3561 13.8677 12.3269 13.9133C12.1494 14.2138 11.6903 14.6337 11.4885 15.1772C11.3499 15.5799 11.1554 15.8055 11.0313 16.3078L11.0022 16.3538C10.9922 16.2058 11.039 15.7448 11.0049 15.8393C10.5263 16.8063 10.1144 17.805 9.77213 18.8282C9.22235 20.6357 8.58233 23.096 8.48087 26.2966C8.45643 26.5393 8.47816 26.8111 8.45613 27.0295C7.15405 28.5163 6.26683 29.7752 5.93139 30.4278C4.248 33.029 2.39303 37.0829 0.594851 43.4955C1.39488 41.7438 2.35156 40.068 3.45322 38.4886C1.95793 41.8923 0.512519 47.2374 0.223557 55.4687C0.58652 53.7653 1.05048 52.085 1.61298 50.4367C1.35477 55.9255 1.99409 62.7303 5.46404 70.4079C7.52434 74.9239 12.267 84.0947 23.8555 91.2513L23.8545 91.252C23.8545 91.252 27.7968 94.1867 34.5733 96.3861C35.0741 96.5678 35.5814 96.7467 36.0992 96.9202C35.9367 96.8546 35.7795 96.7856 35.6269 96.7147C40.1374 98.0661 44.8205 98.7544 49.5291 98.758C67.0752 98.7729 72.2501 91.7267 72.2501 91.7267C72.2501 91.7267 72.2319 91.7405 72.1987 91.7645C72.4463 91.5314 72.6848 91.2891 72.9142 91.0376C70.1458 93.6518 63.8281 93.8253 61.4658 93.6367C65.4946 92.4535 68.1456 91.4526 73.3023 89.4781C73.9057 89.2545 74.5228 88.9994 75.1534 88.7129C75.2216 88.6829 75.2905 88.6503 75.359 88.6192C75.4841 88.5609 75.608 88.5058 75.7343 88.4445C78.2467 87.2605 80.6092 85.7815 82.7717 84.0387C87.95 79.9021 89.0767 75.87 89.6657 73.2114C89.5835 73.4662 89.3276 74.0603 89.1478 74.445C87.8142 77.2978 84.8569 79.0483 81.645 80.5496C83.1734 78.5442 84.5907 76.4566 85.8906 74.2962C86.939 73.2562 87.2661 71.6294 88.049 70.5362Z"
          fill="url(#paint6_radial_2_3887)"
        />
        <path
          d="M81.7461 80.4269C83.8575 78.0991 85.7535 75.4365 87.1897 72.4173C90.8856 64.6466 96.6 51.7262 92.0994 38.232C88.5424 27.5666 83.6587 21.7348 77.4578 16.0379C67.3873 6.78646 64.5747 2.65635 64.5747 0.200317C64.5747 0.200317 52.9472 13.162 57.99 26.6808C63.0328 40.1996 73.3606 39.704 80.1934 53.8116C88.2338 70.4127 73.6881 88.5285 61.6594 93.5991C62.3958 93.4355 88.3991 87.5511 89.7657 72.6774C89.7348 72.9509 89.1488 77.0647 81.7461 80.4269Z"
          fill="url(#paint7_radial_2_3887)"
        />
        <path
          d="M48.0593 32.1888C48.0987 31.3104 47.643 30.7205 40.3788 30.0391C37.3901 29.7631 36.2457 27.0008 35.8968 25.8383C34.8341 28.5992 34.3953 31.4963 34.6312 35.0006C34.7925 37.2963 36.3348 39.7603 37.0721 41.207C37.0721 41.207 37.236 40.9941 37.3116 40.9154C38.6999 39.47 44.5167 37.2676 45.0632 36.9549C45.6656 36.5744 47.9581 34.8994 48.0593 32.1888Z"
          fill="url(#paint8_linear_2_3887)"
        />
        <path
          d="M16.0803 15.8725C15.9761 15.6904 15.9201 16.2485 15.8399 16.0689C15.2435 14.6854 14.8806 12.4431 14.9665 10.8584C14.9665 10.8584 13.7328 11.4207 12.7116 13.7691C12.522 14.1912 12.4004 14.4241 12.2789 14.657C12.2231 14.7249 12.4057 13.8857 12.3765 13.9314C12.1991 14.2319 11.74 14.6518 11.5406 15.1709C11.3752 15.5955 11.2051 15.8234 11.0785 16.35C11.0396 16.4931 11.1178 15.7167 11.0837 15.8112C8.70884 20.4011 8.25551 27.3411 8.50581 27.0476C13.5617 21.649 19.3557 20.3686 19.3557 20.3686C18.7392 19.9145 17.3997 18.6033 16.0804 15.8725H16.0803Z"
          fill="url(#paint9_linear_2_3887)"
        />
        <path
          d="M35.264 72.3257C28.2804 69.344 20.3409 65.1387 20.6406 55.5851C21.0488 43.0031 32.3739 45.4899 32.3739 45.4899C31.9465 45.5939 30.8039 46.4075 30.3989 47.2747C29.971 48.3592 29.1901 50.808 31.5559 53.3745C35.2707 57.4001 23.9237 62.9254 41.438 73.3632C41.8797 73.6036 37.3323 73.2199 35.2642 72.3257H35.264Z"
          fill="url(#paint10_linear_2_3887)"
        />
        <path
          d="M32.7831 66.0557C37.7352 67.7791 43.5042 67.4768 46.958 65.5691C49.2702 64.2819 52.2365 62.2203 54.0616 62.7292C52.4814 62.1046 51.2846 61.8128 49.8449 61.7415C49.5997 61.7415 49.3058 61.7363 49.0388 61.7094C48.5115 61.7077 47.9845 61.7366 47.4605 61.7958C46.5691 61.8778 45.5809 62.4402 44.6826 62.3499C44.634 62.345 45.554 61.9719 45.4792 61.9889C45.0032 62.0881 44.4861 62.1096 43.9397 62.1773C43.5924 62.2159 43.2938 62.2594 42.949 62.2737C32.6343 63.1484 23.9169 56.6835 23.9169 56.6835C23.1749 59.1825 27.2388 64.1254 32.7832 66.0557H32.7831Z"
          fill="url(#paint11_linear_2_3887)"
        />
        <path
          d="M81.7278 80.4934C92.1607 70.25 97.4391 57.7986 95.2076 43.8328C95.2076 43.8328 96.0991 50.9943 92.7189 58.3188C94.3428 51.1681 94.5317 42.2818 90.2173 33.0796C84.4588 20.7969 74.9882 14.3338 71.3725 11.6375C65.8942 7.55209 63.6233 3.39243 63.5823 2.53406C61.9458 5.88712 56.9952 17.3778 63.0505 27.2736C68.7236 36.5449 77.6604 39.2968 83.9167 47.8012C95.4426 63.4683 81.7278 80.4934 81.7278 80.4934Z"
          fill="url(#paint12_linear_2_3887)"
        />
        <path
          d="M80.233 53.8412C76.5869 46.3091 72.0363 43.0238 67.7316 39.4631C68.2324 40.1643 68.3558 40.412 68.633 40.8654C72.4218 44.9034 78.0087 54.7532 73.9525 67.1181C66.3174 90.3928 35.7771 79.4328 32.5753 76.3541C33.8706 89.8245 56.4171 96.2704 71.0969 87.535C79.4503 79.6274 86.2079 66.1847 80.233 53.8412Z"
          fill="url(#paint13_linear_2_3887)"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_2_3887"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(91.188 24.8595) rotate(2.55481) scale(34.446 50.6293)"
        >
          <stop offset="0.045" stopColor="#FFEA00" />
          <stop offset="0.12" stopColor="#FFDE00" />
          <stop offset="0.254" stopColor="#FFBF00" />
          <stop offset="0.429" stopColor="#FF8E00" />
          <stop offset="0.769" stopColor="#FF272D" />
          <stop offset="0.872" stopColor="#E0255A" />
          <stop offset="0.953" stopColor="#CC2477" />
          <stop offset="1" stopColor="#C42482" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_2_3887"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(66.6417 19.5445) scale(97.0809 97.0809)"
        >
          <stop stopColor="#00CCDA" />
          <stop offset="0.22" stopColor="#0083FF" />
          <stop offset="0.261" stopColor="#007AF9" />
          <stop offset="0.33" stopColor="#0060E8" />
          <stop offset="0.333" stopColor="#005FE7" />
          <stop offset="0.438" stopColor="#2639AD" />
          <stop offset="0.522" stopColor="#401E84" />
          <stop offset="0.566" stopColor="#4A1475" />
        </radialGradient>
        <linearGradient
          id="paint2_linear_2_3887"
          x1="54.3771"
          y1="73.2359"
          x2="35.2026"
          y2="10.5128"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#000F43" stopOpacity="0.4" />
          <stop offset="0.485" stopColor="#001962" stopOpacity="0.173" />
          <stop offset="1" stopColor="#002079" stopOpacity="0" />
        </linearGradient>
        <radialGradient
          id="paint3_radial_2_3887"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(99.6542 63.8474) rotate(5.76178) scale(32.751 32.751)"
        >
          <stop offset="0.003" stopColor="#FFEA00" />
          <stop offset="0.497" stopColor="#FF272D" />
          <stop offset="1" stopColor="#C42482" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_2_3887"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(99.8587 32.3043) rotate(5.76178) scale(54.6915)"
        >
          <stop offset="0.003" stopColor="#FFE900" />
          <stop offset="0.157" stopColor="#FFAF0E" />
          <stop offset="0.316" stopColor="#FF7A1B" />
          <stop offset="0.472" stopColor="#FF4E26" />
          <stop offset="0.621" stopColor="#FF2C2E" />
          <stop offset="0.762" stopColor="#FF1434" />
          <stop offset="0.892" stopColor="#FF0538" />
          <stop offset="1" stopColor="#FF0039" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_2_3887"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(102.465 83.5229) rotate(5.76178) scale(50.1854 50.1854)"
        >
          <stop offset="0.003" stopColor="#FF272D" />
          <stop offset="0.497" stopColor="#C42482" />
          <stop offset="0.986" stopColor="#620700" />
        </radialGradient>
        <radialGradient
          id="paint6_radial_2_3887"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(71.8571 39.6675) scale(78.3434)"
        >
          <stop offset="0.156" stopColor="#FFEA00" />
          <stop offset="0.231" stopColor="#FFDE00" />
          <stop offset="0.365" stopColor="#FFBF00" />
          <stop offset="0.541" stopColor="#FF8E00" />
          <stop offset="0.763" stopColor="#FF272D" />
          <stop offset="0.796" stopColor="#F92433" />
          <stop offset="0.841" stopColor="#E91C45" />
          <stop offset="0.893" stopColor="#CF0E62" />
          <stop offset="0.935" stopColor="#B5007F" />
        </radialGradient>
        <radialGradient
          id="paint7_radial_2_3887"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(65.9626 0.329422) scale(92.5095 92.5095)"
        >
          <stop offset="0.279" stopColor="#FFEA00" />
          <stop offset="0.402" stopColor="#FFDD00" />
          <stop offset="0.63" stopColor="#FFBA00" />
          <stop offset="0.856" stopColor="#FF9100" />
          <stop offset="0.933" stopColor="#FF6711" />
          <stop offset="0.994" stopColor="#FF4A1D" />
        </radialGradient>
        <linearGradient
          id="paint8_linear_2_3887"
          x1="18.1622"
          y1="35.7443"
          x2="53.7743"
          y2="30.3976"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C42482" stopOpacity="0.5" />
          <stop offset="0.474" stopColor="#FF272D" stopOpacity="0.5" />
          <stop offset="0.486" stopColor="#FF2C2C" stopOpacity="0.513" />
          <stop offset="0.675" stopColor="#FF7A1A" stopOpacity="0.72" />
          <stop offset="0.829" stopColor="#FFB20D" stopOpacity="0.871" />
          <stop offset="0.942" stopColor="#FFD605" stopOpacity="0.964" />
          <stop offset="1" stopColor="#FFE302" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_2_3887"
          x1="14.6091"
          y1="26.2294"
          x2="10.5712"
          y2="11.7457"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#891551" stopOpacity="0.6" />
          <stop offset="1" stopColor="#C42482" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_2_3887"
          x1="22.2714"
          y1="47.2126"
          x2="30.5813"
          y2="58.806"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="#891551" stopOpacity="0.5" />
          <stop offset="0.484" stopColor="#FF272D" stopOpacity="0.5" />
          <stop offset="1" stopColor="#FF272D" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_2_3887"
          x1="38.1594"
          y1="67.5089"
          x2="38.9138"
          y2="60.0569"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C42482" />
          <stop offset="0.083" stopColor="#C42482" stopOpacity="0.81" />
          <stop offset="0.206" stopColor="#C42482" stopOpacity="0.565" />
          <stop offset="0.328" stopColor="#C42482" stopOpacity="0.362" />
          <stop offset="0.447" stopColor="#C42482" stopOpacity="0.204" />
          <stop offset="0.562" stopColor="#C42482" stopOpacity="0.091" />
          <stop offset="0.673" stopColor="#C42482" stopOpacity="0.023" />
          <stop offset="0.773" stopColor="#C42482" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_2_3887"
          x1="62.3761"
          y1="3.81811"
          x2="92.9907"
          y2="72.2772"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF14F" />
          <stop offset="0.268" stopColor="#FFEE4C" />
          <stop offset="0.452" stopColor="#FFE643" />
          <stop offset="0.612" stopColor="#FFD834" />
          <stop offset="0.757" stopColor="#FFC41E" />
          <stop offset="0.892" stopColor="#FFAB02" />
          <stop offset="0.902" stopColor="#FFA900" />
          <stop offset="0.949" stopColor="#FFA000" />
          <stop offset="1" stopColor="#FF9100" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_2_3887"
          x1="68.4212"
          y1="43.1901"
          x2="53.9193"
          y2="82.1274"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF8E00" />
          <stop offset="0.04" stopColor="#FF8E00" stopOpacity="0.858" />
          <stop offset="0.084" stopColor="#FF8E00" stopOpacity="0.729" />
          <stop offset="0.13" stopColor="#FF8E00" stopOpacity="0.628" />
          <stop offset="0.178" stopColor="#FF8E00" stopOpacity="0.557" />
          <stop offset="0.227" stopColor="#FF8E00" stopOpacity="0.514" />
          <stop offset="0.282" stopColor="#FF8E00" stopOpacity="0.5" />
          <stop offset="0.389" stopColor="#FF8E00" stopOpacity="0.478" />
          <stop offset="0.524" stopColor="#FF8E00" stopOpacity="0.416" />
          <stop offset="0.676" stopColor="#FF8E00" stopOpacity="0.314" />
          <stop offset="0.838" stopColor="#FF8E00" stopOpacity="0.172" />
          <stop offset="1" stopColor="#FF8E00" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_2_3887">
          <rect width="96" height="98.8718" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
